import { extendObservable, runInAction } from 'mobx';

import { VideosController } from '../../../networking/controllers/VideosController';
import { Logger } from '../../../helpers/Logger';

class VideosStoreClass {
  constructor() {
    extendObservable(this, {
      videos: null,
    });
    this.id = null;
  }

  async fetchVideos(id) {
    try {
      if (this.id !== id) {
        this.id = id;
        runInAction(() => {
          this.videos = null;
        });
      }
      const videos = await VideosController.all(id);
      runInAction(() => {
        this.videos = videos;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }
}

export const VideosStore = new VideosStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-detail/stores/VideosStore.js